import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@services/translate/translate.service';
import { HttpClient } from '@angular/common/http';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { GameSessionService } from '@services/game-sessions/game-session.service';
import { AngieScreensService } from '@services/angie-screens/angie-screens.service';
import { PackageService } from '@services/packages/package.service';

@Component({
    selector: 'app-app-highscore-reset-dialog',
    templateUrl: './app-highscore-reset-dialog.component.html',
    styleUrls: ['./app-highscore-reset-dialog.component.scss'],
    providers: [AngieScreensService, GameSessionService],
    standalone: false
})
export class AppHighscoreResetDialogComponent implements OnInit {

  public uuids;
  public paramsScreen = null;
  public columns: any = [{ prop: 'name' }, { prop: 'uuid' }];
  public systemMessages = null;
  public isTouch2015 = true;

  constructor(
    public dialogRef: MatDialogRef<AppHighscoreResetDialogComponent>, public gameSessionsService: GameSessionService, public angieScreenService: AngieScreensService,
    public packageService: PackageService, public ts: TranslateService, public snackbar: SnackbarService, public http: HttpClient) {
  }

  async ngOnInit() {
    this.systemMessages = this.ts.get('system');
    this.paramsScreen = { uuid: { $in: this.uuids } }
    this.angieScreenService.find(0, 1, this.paramsScreen).then(res => {
      if (!res.data[0]) {
        this.isTouch2015 = false;
        this.paramsScreen = { _id: { $in: this.uuids } };
        this.columns = [{ prop: 'title', name: 'Test' }];
      }
    });
  }

  public async onReset(event): Promise<any> {
    let err;
    const result = await this.gameSessionsService.remove(this.isTouch2015 ? event.row.uuid : event.row._id).catch(error => {
      console.warn(error);
      err = error;
    });
    this.snackbar.open(this.systemMessages.general[!!err ? 'failed' : 'savedChanges']);
  }

}
